module.exports = __webpack_public_path__ + "h5/img/mfe_16.f75df7d8.jpg";